import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { baseurl } from "../Components/Url";
import { isTokenExpiredPayload } from "../utils/session";

export const fetchUserDetails = createAsyncThunk('user/fetchUserDetails', async ({userid,token}) => {
    const response = await fetch(`${baseurl}/user/detail/get`,{
        method:"POST",
        body: JSON.stringify({
           user_id:userid
          }),
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
    });
  
    const data = await response.json();
    if (isTokenExpiredPayload(response.status, data)) {
      throw new Error("Token has expired");
    }

    if (!response.ok || !data.status) {
      throw new Error(data.description || data.msg || "Failed to fetch user details");
    }
    return data.data[0];
  });
  
  const userSlice = createSlice({
    name: 'user',
    initialState: {
      userDetails: {},
      status: 'idle',
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchUserDetails.pending, (state) => {
          state.status = 'loading';
        })
        .addCase(fetchUserDetails.fulfilled, (state, action) => {
          state.status = 'succeeded';
          state.userDetails = action.payload;
        })
        .addCase(fetchUserDetails.rejected, (state, action) => {
          state.status = 'failed';
          state.error = action.error.message;
        });
    },
  });
  
  export default userSlice.reducer;